export default "__VITE_ASSET__Cy5HNNI8__"